import { createComponentStore } from "@tecnobit-srl/components-store";
import { jsx } from "react/jsx-runtime";
//#region src/index.tsx
var { Component: InnerContent, ComponentStoreProvider: RoutableTypesProvider, useAddComponent: useAddRoutableType } = createComponentStore("routable-types");
function Routable({ type, props }) {
	return /* @__PURE__ */ jsx(InnerContent, {
		id: type,
		p: props
	});
}
//#endregion
export { Routable, RoutableTypesProvider, useAddRoutableType };
